<template>
  <div class="user-info">
    <div class="user-info-header">
      <div class="user-info-header-left">
        <img class="avatar-img" src="@/assets/style/avatar-icon.png" alt="" />
        <div class="user-info-wrap">
          <span class="user-info-name">{{userInfo.username || "User"}}</span>
           <span class="user-info-phone">{{formatPhone(phone)}}</span>
        </div>
      </div>
      <div class="user-info-header-right" v-if="!infoErrorCode.includes(preCheckData.code)">资料已完善</div>
      <div class="user-info-header-right-uncomplete" @click="toIdCardBinding" v-else>
        <span>资料未完善</span>
        <img src="@/assets/style/oride-icon.png" alt="">
      </div> 
    </div>
    <!--在途订单和银行卡-->
    <div class="user-info-content">
      <div class="user-info-content-left" @click="toOrderDetails">
        <div class="user-info-content-left-wrap">
          <span class="user-info-content-left-title">在途订单</span>
          <span class="user-info-content-left-desc">点击查看</span>
        </div>
        <img src="@/assets/style/order-icon.png" alt="" />
      </div>
      <div class="user-info-content-right" @click="toBankCard">
        <div class="user-info-content-right-wrap">
          <span class="user-info-content-right-title">银行卡</span>
          <span class="user-info-content-right-desc">点击查看</span>
        </div>
        
        <img src="@/assets/style/bank-card-icon.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { formatPhone } from "@/common/index.js";
import { infoErrorCode } from "@/utils/const";

export default {
  name: "userInfo",
  data() {
    return {
      formatPhone,
      infoErrorCode,
      phone:localStorage.getItem("phone") || "", 

    };
  },
  methods: {
    toIdCardBinding() {
      this.$router.push({ name: "idCardBinding" });
    },
    toOrderDetails() {
      this.$router.push({ name: "orderList" });
      this.$store.commit("setRouterFlag", "2");
    },
     toBankCard() {
      this.$router.push({ name: "addBank" });
    },
  },
  computed: {
    userInfo(){
      return this.$store.state.userInfo;
    },
    preCheckData() {
      return this.$store.state.preCheckData;
    },
  },
};
</script>

<style scoped lang="scss">
.user-info {
}
.user-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .user-info-header-left {
    display: flex;
    .avatar-img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      margin-right: 12px;
    }
    .user-info-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      color: #fff;
      .user-info-name {
        font-size: 24px;
        font-weight: 500;
      }
      .user-info-phone {
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
  .user-info-header-right {
    height: 28px;
    background: #fff;
    border-radius: 35px;
    padding: 0px 10px;
    font-size: 14px;
    color: #1D70F7;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user-info-header-right-uncomplete{
    height: 28px;
    background: #EAEAEA;
    border-radius: 35px;
    padding: 0px 10px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(51,51,51,0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 13px;
      height: 13px;
      margin-left: 8px;
    }
  }
}
.user-info-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 26px;
  .user-info-content-left,.user-info-content-right{
    padding: 6px 20px 6px 12px;
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 39%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    background: #fff;
    img{
      width: 52px;
      height: 52px;
    }
    .user-info-content-left-wrap,.user-info-content-right-wrap{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 16px;
      color: #333333;
      .user-info-content-left-desc,.user-info-content-right-desc{
        font-size: 10px;
        font-weight: 500;
        color: #D5D5D5;
        padding-top: 4px;
      }
    }
  }
}
</style>
